// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';
import Layout from '../components/Layout';
import LoaderContainer from '../components/LoaderContainer';
import TextHeader1 from '../components/TextHeader1';
import TextParagraph from '../components/TextParagraph';
import TextStrong from '../components/TextStrong';
import InputSearch from '../components/InputSearch';
import Container from '../components/Container';
import ListItemMerchant from '../components/ListItemMerchant';
import ButtonIcon from '../components/ButtonIcon'
import type { TProps } from './types';
import { EVENT_TYPES } from '../HOCs/withEventManager';


function Search(props: TProps): React.Node {
  const [isFetching, setIsFetching] = React.useState(false);
  const onSelectMerchant = merchant => () => props.navigateTo('/form', { merchant });
  const onSearchChange = (name) => {
    setIsFetching(true);
    props.asyncFetchMerchants({ name })
      .catch((error) => {
        props.dispatchEvent(EVENT_TYPES.error, error.toObject(), () => props.dispatchEvent(EVENT_TYPES.exit, {}));
      })
      .finally(() => setIsFetching(false));
  };

  return (
    <Layout {...props} showBack showLogo showExit padded>
      <TextHeader1>
        <TextStrong extra>Select your merchant</TextStrong>
      </TextHeader1>
      <Container my={16}>
        <InputSearch value={props.merchants.query.name} onChange={onSearchChange} />
      </Container>

      <LoaderContainer size={30} isLoading={isFetching}>
        {props.merchants.list.length === 0 && (
          <Container>
            <Container centered flex="column" pa={36}>
              <ButtonIcon name="info-circle-fill" color="#4b4b4b" />
              <TextParagraph>No results found</TextParagraph>
            </Container>
          </Container>
        )}

        {props.merchants.list.length > 0 && (
          <Container height="calc(100vh - 180px)" overflow="scroll" relative left={-24} width="100vw">
            {props.merchants.list.map(merchant => (
              <ListItemMerchant
                key={merchant.name}
                merchant={merchant}
                onClick={onSelectMerchant(merchant)} />
            ))}
          </Container>
        )}
      </LoaderContainer>
    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(Search, { name: 'Search' });
